import { render, staticRenderFns } from "./SoFileChangeNotice.vue?vue&type=template&id=55707ede&scoped=true"
import script from "./SoFileChangeNotice.vue?vue&type=script&lang=js"
export * from "./SoFileChangeNotice.vue?vue&type=script&lang=js"
import style0 from "./SoFileChangeNotice.vue?vue&type=style&index=0&id=55707ede&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55707ede",
  null
  
)

export default component.exports